import RenderAfterTimeout from './RenderAfterTimeout';

export default RenderAfterTimeout;
